<template>
  <div v-if="showContentDeliverer">
    <div class="alert alert-success  text-center" role="alert">
      <h2>Итоги</h2>
    </div>

    <div class="row">
      <div class="col mt-1">
        <input v-model="dateFrom" type="date" class="form-control fs-5" placeholder="Дата" />
      </div>
      <div class="col mt-1">
        <input v-model="dateTo" type="date" class="form-control fs-5" placeholder="Дата" />
      </div>
    </div>

    <div class="row">
      <div class="col mt-1">
        <button class="btn btn-success" @click="getUserResults()">ОБНОВИТЬ</button>
      </div>
    </div>

    <div>
      <table class="table">
        <thead>
          <tr>
            <th scope="col">Ягода</th>
            <th scope="col">Сумма, руб</th>
            <th scope="col">Сдано, кг</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in results" :key="index">
            <td>{{ row.label }}</td>
            <td>{{ row.sum.toFixed(2) }}</td>
            <td>{{ row.weight.toFixed(2) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <br />
    <div class="d-flex justify-content-center">
      <img class="img img-fluid" width="150" src="moroshka.png" alt="" />
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */

import { onMounted, ref } from "vue";
import useCommonMixin from "@/components/commonMixin.js";
import { useStore } from "vuex";

export default {
  name: "Balance",

  components: {},

  setup(props) {
    useCommonMixin();
    const store = useStore();
    const { userBalance, getUserBalance, showContentDeliverer } = useCommonMixin();
    const payoffSum = ref("");
    const card = ref("");

    const dateFrom = ref("");
    const dateTo = ref("");

    const results = ref([]);
    const init = async () => {
      let today = new Date();
      var lastDayOfYear = new Date(today.getFullYear(), 12, 1);
      var firstDayOfYear = new Date(today.getFullYear(), 0, 2);      
      dateFrom.value = firstDayOfYear.toISOString().slice(0, 10);
      dateTo.value = lastDayOfYear.toISOString().slice(0, 10);
      getUserResults()
      getUserBalance();
    };

    const getUserResults = async () => {
      let response = await store.dispatch("FETCHresults", {dateFrom: dateFrom.value, dateTo: dateTo.value});
      results.value = response.status ? response.data : [];
    }

    onMounted(init);

    return {
      showContentDeliverer,
      payoffSum,
      card,
      userBalance,
      results,
      dateFrom,
      dateTo,
      getUserResults,
    };
  }
};
</script>

<style scoped></style>
